/**
 * 学习乐园 · 找假币天平（game-tianping.js）
 * ============================================================
 * 「逻辑与推理」组新作：三档——入门 6 球称 2 次（默认档，假币偏轻）、
 * 进阶 9 球称 2 次（偏轻）、挑战 12 球称 3 次（不知轻重）。
 * 点球循环切换「未放→左盘→右盘」，称一次得结果。
 *
 * 反馈口径（栏目底线——即时且可解释）：每称一次讲清「这次排除了谁、
 * 还剩几种可能」——可能性由候选集（假币编号×轻重）现算，是真实的
 * 信息论账本，不是背口诀。指认错了讲反证：它的假设与哪次称量矛盾。
 *
 * 成绩口径：不计时，记各档完成局数与最少称量次数，全部存本机 localStorage。
 *
 * 冒烟钩子：window.STTianping 暴露 weighResult / candidateCount /
 * bestSplit 与 state()（{n, fake, heavy, used, maxW, cands}）。
 */
(function (global) {
  'use strict';

  var PREF_KEY = 'study-tianping';
  var RECORD_KEY = 'study-tianping-record';

  /* ============ 引擎：纯函数 ============ */

  // 一次称量的结果：假币在 idx、轻重 kind（'light'|'heavy'）时，left/right 两盘的指针
  // 真球 10g；假币 9g（轻）或 11g（重）
  function weighResult(n, left, right, fakeIdx, kind) {
    var sl = 0, sr = 0;
    for (var i = 0; i < left.length; i++) sl += (left[i] === fakeIdx ? (kind === 'light' ? 9 : 11) : 10);
    for (var j = 0; j < right.length; j++) sr += (right[j] === fakeIdx ? (kind === 'light' ? 9 : 11) : 10);
    if (sl > sr) return 'L';
    if (sl < sr) return 'R';
    return '=';
  }

  // 候选集：所有与历史称量相容的 (球, 轻重) 组合。history: [{left,right,r}]
  function candidates(n, history, allowHeavy) {
    var out = [];
    for (var i = 0; i < n; i++) {
      var kinds = allowHeavy ? ['light', 'heavy'] : ['light'];
      for (var k = 0; k < kinds.length; k++) {
        var ok = true;
        for (var h = 0; h < history.length; h++) {
          if (weighResult(n, history[h].left, history[h].right, i, kinds[k]) !== history[h].r) {
            ok = false;
            break;
          }
        }
        if (ok) out.push({ ball: i, kind: kinds[k] });
      }
    }
    return out;
  }

  function candidateCount(n, history, allowHeavy) {
    return candidates(n, history, allowHeavy).length;
  }

  // 查一查建议：把剩余候选球均分三组（左盘/右盘/盘外）的称法
  function bestSplit(n, history, allowHeavy) {
    var cands = candidates(n, history, allowHeavy);
    var balls = [];
    for (var i = 0; i < cands.length; i++) {
      if (balls.indexOf(cands[i].ball) < 0) balls.push(cands[i].ball);
    }
    if (balls.length < 2) return null;   // 已可指认
    // 均分：左盘、右盘各拿约三分之一，盘外留余
    var third = Math.ceil(balls.length / 3);
    return {
      left: balls.slice(0, third),
      right: balls.slice(third, third * 2),
      off: balls.slice(third * 2)
    };
  }

  /* ============ UI：挂载与状态 ============ */

  var LEVELS = [
    { n: 6, maxW: 2, heavy: false, name: '入门 6 球', hint: '默认档 · 假币偏轻 · 称 2 次' },
    { n: 9, maxW: 2, heavy: false, name: '进阶 9 球', hint: '偏轻 · 称 2 次卡满' },
    { n: 12, maxW: 3, heavy: true, name: '挑战 12 球', hint: '不知轻重 · 称 3 次' }
  ];

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return text != null || cls ? node : node;
  }

  var root = null;
  var ui = {};
  var S = {
    level: 0, n: 6, maxW: 2, allowHeavy: false,
    fake: 0, fakeHeavy: false,
    history: [],                 // [{left:[], right:[], r:'L'|'R'|'='}]
    place: {},                   // ball -> 'L'|'R'|undefined
    accused: -1, accuseKind: null,
    ended: false, soundOn: true, resetArm: false, resetTimer: null
  };

  function renderLevels() {
    var box = ui.levels;
    box.textContent = '';
    for (var i = 0; i < LEVELS.length; i++) {
      (function (lv, idx) {
        var b = el('button', 'st-llk-pack-btn');
        b.type = 'button';
        b.setAttribute('data-level', String(lv.n));
        b.setAttribute('role', 'radio');
        b.appendChild(el('span', 'st-llk-pack-name', lv.name));
        b.appendChild(el('small', 'st-llk-pack-hint', lv.hint));
        b.addEventListener('click', function () {
          if (S.level === idx) return;
          newGame(idx);
        });
        box.appendChild(b);
      })(LEVELS[i], i);
    }
  }

  function syncLevels() {
    var btns = ui.levels.querySelectorAll('[data-level]');
    for (var i = 0; i < btns.length; i++) {
      var on = Number(btns[i].getAttribute('data-level')) === S.n;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function buildBalls() {
    ui.balls.textContent = '';
    for (var i = 0; i < S.n; i++) {
      (function (idx) {
        var b = el('button', 'st-tp-ball', String(idx + 1));
        b.type = 'button';
        b.setAttribute('data-ball', String(idx));
        b.addEventListener('click', function () { onBall(idx); });
        ui.balls.appendChild(b);
      })(i);
    }
    renderBalls();
  }

  function renderBalls() {
    var balls = ui.balls.children;
    for (var i = 0; i < balls.length; i++) {
      var node = balls[i];
      node.classList.toggle('is-left', S.place[i] === 'L');
      node.classList.toggle('is-right', S.place[i] === 'R');
      node.classList.toggle('is-accused', S.accused === i);
      node.setAttribute('aria-label', i + 1 + ' 号球，'
        + (S.place[i] === 'L' ? '在左盘' : S.place[i] === 'R' ? '在右盘' : '未上盘'));
    }
    ui.left.textContent = pans('L');
    ui.right.textContent = pans('R');
  }

  function pans(side) {
    var list = [];
    for (var i = 0; i < S.n; i++) { if (S.place[i] === side) list.push(i + 1); }
    return list.length ? list.join('、') + ' 号' : '（空）';
  }

  function renderStatus() {
    if (S.ended) return;
    var left = 0, right = 0;
    for (var i = 0; i < S.n; i++) { if (S.place[i] === 'L') left++; if (S.place[i] === 'R') right++; }
    ui.status.className = 'st-status';
    ui.status.textContent = LEVELS[S.level].name + ' · 已称 ' + S.history.length + '/' + S.maxW
      + ' 次 · 左盘 ' + left + ' 枚右盘 ' + right + ' 枚' + (left !== right ? '（两盘枚数不等也可称，但等枚数信息最多）' : '');
  }

  function renderNote(text, tone) {
    ui.note.textContent = text || '';
    ui.note.className = 'st-llk-note' + (tone ? ' is-' + tone : '');
  }

  function renderHistory() {
    var box = ui.history;
    box.textContent = '';
    if (!S.history.length) {
      box.appendChild(el('li', 'st-tp-h-item st-tp-h-empty', '还没称过——把球点进左右盘，再点「称一次」。'));
      return;
    }
    for (var h = 0; h < S.history.length; h++) {
      var w = S.history[h];
      var li = el('li', 'st-tp-h-item');
      li.appendChild(el('strong', '', '第 ' + (h + 1) + ' 次：'));
      li.appendChild(document.createTextNode('左[' + w.left.map(function (x) { return x + 1; }).join('、') + '] vs 右['
        + w.right.map(function (x) { return x + 1; }).join('、') + '] → '));
      li.appendChild(el('strong', 'st-tp-h-r', w.r === 'L' ? '左沉' : w.r === 'R' ? '右沉' : '平'));
      box.appendChild(li);
    }
  }

  function renderRecord() {
    var box = ui.record;
    box.textContent = '';
    var rec = loadRecord();
    for (var i = 0; i < LEVELS.length; i++) {
      var lv = LEVELS[i];
      var r = rec['n' + lv.n];
      var bits = [];
      if (r && r.wins) bits.push(r.wins + ' 局');
      if (r && r.best) bits.push('最少称 ' + r.best + ' 次');
      box.appendChild(recordStat(
        lv.n + ' 球完成',
        bits.length ? bits.join(' · ') : '还没找对过——指认正确就记在这里'
      ));
    }
  }

  function recordStat(label, value) {
    var d = el('div', 'st-llk-stat');
    d.appendChild(el('span', 'st-llk-stat-label', label));
    d.appendChild(el('strong', 'st-llk-stat-value', value));
    return d;
  }

  /* ---- 音效（WebAudio 本地合成） ---- */

  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var actx = null;
  function sfx(kind) {
    if (!S.soundOn) return;
    try {
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return;
      if (!actx) actx = new AC();
      if (actx.state === 'suspended' && actx.resume) actx.resume();
      var t = actx.currentTime;
      var seq;
      if (kind === 'ok') seq = [[523, 0], [659, 0.07]];
      else if (kind === 'win') seq = [[523, 0], [659, 0.1], [784, 0.2], [1046, 0.3]];
      else if (kind === 'bad') seq = [[196, 0], [185, 0.09]];
      else seq = [[330, 0]];
      for (var i = 0; i < seq.length; i++) {
        var o = actx.createOscillator();
        var g = actx.createGain();
        o.type = 'triangle';
        o.frequency.setValueAtTime(SFX_MOBILE && seq[i][0] < 500 ? seq[i][0] * 2 : seq[i][0], t + seq[i][1]);
        g.gain.setValueAtTime(0.0001, t + seq[i][1]);
        g.gain.exponentialRampToValueAtTime(SFX_MOBILE ? 0.42 : 0.18, t + seq[i][1] + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t + seq[i][1] + (SFX_MOBILE ? 0.2 : 0.14));
        o.connect(g); g.connect(actx.destination);
        o.start(t + seq[i][1]); o.stop(t + seq[i][1] + (SFX_MOBILE ? 0.26 : 0.16));
      }
    } catch (e) { /* 音频不可用静默 */ }
  }

  /* ---- 交互 ---- */

  function onBall(idx) {
    if (S.ended) return;
    if (S.place[idx] === 'L') S.place[idx] = 'R';
    else if (S.place[idx] === 'R') delete S.place[idx];
    else S.place[idx] = 'L';
    sfx('sel');
    renderBalls();
    renderStatus();
  }

  function doWeigh() {
    if (S.ended) return;
    if (S.history.length >= S.maxW) {
      renderNote('称量次数用完了（这一档上限 ' + S.maxW + ' 次）——直接指认假币，或重开一局。', 'bad');
      return;
    }
    var left = [], right = [];
    for (var i = 0; i < S.n; i++) {
      if (S.place[i] === 'L') left.push(i);
      if (S.place[i] === 'R') right.push(i);
    }
    if (!left.length && !right.length) {
      renderNote('两盘都空着——先把球点进左盘或右盘（点一下左盘、再点一下右盘、第三下收回）。', 'bad');
      return;
    }
    var r = weighResult(S.n, left, right, S.fake, S.fakeHeavy ? 'heavy' : 'light');
    S.history.push({ left: left, right: right, r: r });
    S.place = {};
    sfx('ok');
    renderBalls();
    renderHistory();
    renderStatus();
    renderNote(weighExplain(left, right, r), 'ok');
    if (S.history.length >= S.maxW) {
      renderNote(weighExplain(left, right, r) + ' 称量次数已用完——从上面的可能里指认假币'
        + (S.allowHeavy ? '，并选它偏轻还是偏重。' : '。'), 'ok');
    }
  }

  function weighExplain(left, right, r) {
    var cands = candidates(S.n, S.history, S.allowHeavy);
    var head = '第 ' + S.history.length + ' 次结果：' + (r === 'L' ? '左盘沉' : r === 'R' ? '右盘沉' : '两盘一样重')
      + '——现在只剩 ' + cands.length + ' 种可能';
    var detail;
    if (r === '=') {
      detail = '两盘一样重，说明假币不在盘上（它在盘上该边就会轻/重一头）'
        + (S.allowHeavy ? '，或假币虽在盘上但两盘各有等重嫌疑抵不掉——总之盘外嫌疑优先。' : '。');
      if (S.allowHeavy) detail = '两盘一样重——要么假币不在盘上，要么两盘各有一枚嫌疑（一枚偏轻一枚偏重）。';
      else detail = '两盘一样重，说明假币不在盘上——它在盘上该边就会沉下去另一头。';
    } else {
      var heavySide = r === 'L' ? '右' : '左';
      detail = S.allowHeavy
        ? '沉的一边是真球多、轻的一边藏着假币：假币要么在' + heavySide + '盘且偏轻，要么在另一盘且偏重。'
        : '假币偏轻，所以假币在' + (r === 'L' ? '右' : '左') + '盘里，或根本不在盘上（不可能——盘外没有更轻的嫌疑前科时按在盘上算）。';
      if (!S.allowHeavy) detail = '假币偏轻，所以假币要么在' + (r === 'L' ? '右' : '左') + '盘，要么不在盘上（盘上枚数相同时）。';
    }
    return head + '。' + detail;
  }

  /* ---- 查一查：给剩余可能 + 三分称法建议 ---- */

  function checkBoard() {
    if (S.ended) return;
    var cands = candidates(S.n, S.history, S.allowHeavy);
    if (!cands.length) {
      renderNote('算不出与称量历史相容的可能（这不该发生）——重开一局。', 'bad');
      return;
    }
    var names = cands.slice(0, 6).map(function (c) {
      return c.ball + 1 + ' 号' + (S.allowHeavy ? (c.kind === 'light' ? '偏轻' : '偏重') : '');
    });
    if (cands.length > 6) names.push('……');
    if (cands.length === 1) {
      var c0 = cands[0];
      renderNote('已经锁定了：只剩 1 种可能——' + (c0.ball + 1) + ' 号球'
        + (S.allowHeavy ? (c0.kind === 'light' ? '偏轻' : '偏重') : '（偏轻）')
        + '。点它指认' + (S.allowHeavy ? '，选对轻重就赢。' : '就赢。'), 'ok');
      return;
    }
    var split = bestSplit(S.n, S.history, S.allowHeavy);
    var advice = split
      ? '下次称法建议（三分法）：左盘放 ' + ids(split.left) + '，右盘放 ' + ids(split.right)
        + '，' + (split.off.length ? ids(split.off) + ' 留在盘外' : '盘外留空') + '——一次称量把可能切成三份，信息最多。'
      : '';
    renderNote('还剩 ' + cands.length + ' 种可能：' + names.join('、') + '。' + advice, 'ok');
  }

  function ids(arr) {
    if (!arr.length) return '（无）';
    return arr.map(function (b) { return b + 1 + ' 号'; }).join('、');
  }

  /* ---- 指认与判定 ---- */

  function accuse() {
    if (S.ended) return;
    if (S.accused < 0) {
      renderNote('先在球排里点中你要指认的那枚（它会高亮），再点「指认它是假币」。', 'bad');
      return;
    }
    if (S.allowHeavy && !S.accuseKind) {
      renderNote('挑战档不知道假币轻重——先在「它的轻重」里选偏轻或偏重，再指认。', 'bad');
      return;
    }
    var saidKind = S.allowHeavy ? S.accuseKind : 'light';
    var right = S.accused === S.fake && saidKind === (S.fakeHeavy ? 'heavy' : 'light');
    if (right) winGame();
    else failGame(saidKind);
  }

  function contraProof(saidKind) {
    // 反证：假使 accused 是假币（saidKind），哪次称量结果对不上？
    var contra = [];
    for (var h = 0; h < S.history.length; h++) {
      var w = S.history[h];
      var r = weighResult(S.n, w.left, w.right, S.accused, saidKind);
      if (r !== w.r) {
        contra.push('第 ' + (h + 1) + ' 次实际是「' + (w.r === 'L' ? '左沉' : w.r === 'R' ? '右沉' : '平')
          + '」，假使 ' + (S.accused + 1) + ' 号' + (saidKind === 'light' ? '偏轻' : '偏重')
          + '则应是「' + (r === 'L' ? '左沉' : r === 'R' ? '右沉' : '平') + '」——对不上');
      }
    }
    return contra;
  }

  function failGame(saidKind) {
    S.ended = true;
    sfx('bad');
    var contra = contraProof(saidKind);
    ui.status.className = 'st-status is-over';
    ui.status.textContent = '不对——' + (S.accused + 1) + ' 号球不是'
      + (saidKind === 'light' ? '偏轻' : '偏重') + '的假币。真凶是 '
      + (S.fake + 1) + ' 号球' + (S.allowHeavy ? (S.fakeHeavy ? '（偏重）' : '（偏轻）') : '（偏轻）') + '。';
    var msg = contra.length
      ? '反证：' + contra[0] + '。'
      : '反证：' + (S.accused + 1) + ' 号' + (saidKind === 'light' ? '偏轻' : '偏重')
        + '与全部称量历史都对得上？——不，它没被任何一次称量排除，但你选错了唯一性：还有别的可能与你看到的结果同样相容。';
    renderNote(msg + ' 每次称量都是在做排除：剩下可能越少，指认越有底气。', 'bad');
    renderButtons();
  }

  function winGame() {
    S.ended = true;
    sfx('win');
    var used = S.history.length;
    var rec = loadRecord();
    var cur = rec['n' + S.n];
    if (!cur || typeof cur !== 'object' || Array.isArray(cur)) cur = { wins: 0, best: 0 };
    if (typeof cur.wins !== 'number') cur.wins = 0;
    if (typeof cur.best !== 'number') cur.best = 0;
    cur.wins++;
    var isRecord = !cur.best || used < cur.best;
    if (isRecord) cur.best = used;
    rec['n' + S.n] = cur;
    try { localStorage.setItem(RECORD_KEY, JSON.stringify(rec)); } catch (e) { /* 隐私模式静默 */ }
    ui.status.className = 'st-status is-over';
    ui.status.textContent = '找对了！' + (S.fake + 1) + ' 号球就是假币'
      + (S.allowHeavy ? (S.fakeHeavy ? '（偏重）' : '（偏轻）') : '（偏轻）')
      + '——用了 ' + used + ' 次称量' + (isRecord ? '，新纪录！' : '（你这档纪录 ' + cur.best + ' 次）');
    renderNote('这就是三分法：每次称量把可能切成三份（左盘/右盘/盘外），'
      + S.n + ' 球' + (S.allowHeavy ? '两种轻重共 ' + S.n * 2 : '') + '种可能，'
      + '称 ' + S.maxW + ' 次理论上限是 ' + Math.pow(3, S.maxW) + ' 种判别——所以这一档恰好在能力边界内。', 'ok');
    renderRecord();
    renderButtons();
  }

  function loadRecord() {
    try {
      var r = JSON.parse(localStorage.getItem(RECORD_KEY) || '{}');
      return r && typeof r === 'object' && !Array.isArray(r) ? r : {};
    } catch (e) { return {}; }
  }

  function resetRecord() {
    if (!S.resetArm) {
      S.resetArm = true;
      renderButtons();
      if (S.resetTimer) clearTimeout(S.resetTimer);
      S.resetTimer = setTimeout(function () { S.resetArm = false; S.resetTimer = null; renderButtons(); }, 3000);
      return;
    }
    S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    try { localStorage.removeItem(RECORD_KEY); } catch (e) { /* 隐私模式静默 */ }
    renderRecord();
    renderButtons();
    toast('已重置天平的本机成绩');
  }

  function renderButtons() {
    ui.resetBtn.classList.toggle('is-arm', S.resetArm);
    ui.resetBtn.textContent = S.resetArm ? '再点一次确认重置' : '重置成绩';
  }

  function save() {
    try {
      localStorage.setItem(PREF_KEY, JSON.stringify({ v: 1, level: S.level, soundOn: S.soundOn }));
    } catch (e) { /* 存储不可用静默 */ }
  }

  function restorePrefs() {
    try {
      var d = JSON.parse(localStorage.getItem(PREF_KEY) || '{}');
      if (!d || d.v !== 1) return;
      if (d.level >= 0 && d.level < LEVELS.length) S.level = d.level;
      S.soundOn = d.soundOn !== false;
    } catch (e) { /* 忽略脏数据 */ }
  }

  function newGame(levelIdx) {
    var lv = LEVELS[levelIdx];
    S.level = levelIdx;
    S.n = lv.n;
    S.maxW = lv.maxW;
    S.allowHeavy = lv.heavy;
    S.fake = Math.floor(Math.random() * S.n);
    S.fakeHeavy = lv.heavy ? Math.random() < 0.5 : false;
    S.history = [];
    S.place = {};
    S.accused = -1;
    S.accuseKind = null;
    S.ended = false;
    S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    syncLevels();
    buildBalls();
    renderHistory();
    renderAll();
    renderRecord();
    renderNote('「' + lv.name + '」：' + S.n + ' 枚球里有 1 枚假币'
      + (lv.heavy ? '，轻重未知' : '，已知偏轻（比真球轻 1 克）')
      + '。点球放进左/右盘（点一下左盘、再点一下右盘、第三下收回），称 ' + lv.maxW + ' 次内找出来'
      + (lv.heavy ? '，还要说对它偏轻还是偏重。' : '。'), '');
    save();
  }

  function renderAll() {
    renderBalls();
    renderStatus();
    renderButtons();
  }

  function bindSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          S.soundOn = b.getAttribute('data-st-sound') === 'on';
          for (var j = 0; j < btns.length; j++) {
            var on = btns[j] === b;
            btns[j].classList.toggle('is-active', on);
            btns[j].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          save();
        });
      })(btns[i]);
    }
    syncSoundPicker();
  }

  function syncSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      var on = (btns[i].getAttribute('data-st-sound') === 'on') === S.soundOn;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function bindAccuseKind() {
    var btns = root.querySelectorAll('[data-st-tp-kind]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          if (S.ended) return;
          S.accuseKind = b.getAttribute('data-st-tp-kind');
          for (var j = 0; j < btns.length; j++) {
            var on = btns[j] === b;
            btns[j].classList.toggle('is-active', on);
            btns[j].setAttribute('aria-checked', on ? 'true' : 'false');
          }
        });
      })(btns[i]);
    }
  }

  function toast(msg) {
    if (!ui.saved) return;
    ui.saved.textContent = msg;
    ui.saved.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { ui.saved.hidden = true; }, 2200);
  }

  /* ============ boot ============ */

  function boot() {
    root = document.querySelector('[data-st-game]');
    if (!root) return;
    ui.levels = root.querySelector('[data-st-tp-levels]');
    ui.balls = root.querySelector('[data-st-tp-balls]');
    ui.left = root.querySelector('[data-st-tp-left]');
    ui.right = root.querySelector('[data-st-tp-right]');
    ui.history = root.querySelector('[data-st-tp-history]');
    ui.status = root.querySelector('[data-st-status]');
    ui.note = root.querySelector('[data-st-note]');
    ui.record = root.querySelector('[data-st-record]');
    ui.saved = root.querySelector('[data-st-saved]');
    ui.newBtn = root.querySelector('[data-st-new]');
    ui.weighBtn = root.querySelector('[data-st-tp-weigh]');
    ui.accuseBtn = root.querySelector('[data-st-tp-accuse]');
    ui.checkBtn = root.querySelector('[data-st-check]');
    ui.resetBtn = root.querySelector('[data-st-reset]');

    restorePrefs();
    renderLevels();
    bindSoundPicker();
    bindAccuseKind();

    ui.newBtn.addEventListener('click', function () { newGame(S.level); });
    ui.weighBtn.addEventListener('click', doWeigh);
    ui.accuseBtn.addEventListener('click', accuse);
    ui.checkBtn.addEventListener('click', checkBoard);
    ui.resetBtn.addEventListener('click', resetRecord);
    ui.balls.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ball]');
      if (t) S.accused = Number(t.getAttribute('data-ball'));
    });

    newGame(S.level);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }

  /* ============ 冒烟与复用钩子 ============ */

  global.STTianping = {
    weighResult: weighResult,
    candidates: candidates,
    candidateCount: candidateCount,
    bestSplit: bestSplit,
    state: function () {
      return {
        n: S.n, fake: S.fake, fakeHeavy: S.fakeHeavy, heavy: S.allowHeavy,
        maxW: S.maxW, history: S.history.slice(), place: S.place,
        accused: S.accused, accuseKind: S.accuseKind, ended: S.ended,
        cands: candidates(S.n, S.history, S.allowHeavy)
      };
    }
  };
})(typeof window !== 'undefined' ? window : globalThis);
